var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/navigationmanager/parts/createnavigationnode',["require", "exports", "common/parts", "areas/navigationmanager/models/bindable", "areas/navigationmanager/services/mappings"], function (require, exports, Parts, Model, Mapping) {
    "use strict";
    var CreateNavigationNode = (function (_super) {
        __extends(CreateNavigationNode, _super);
        function CreateNavigationNode(target) {
            _super.call(this);
            this._nodeAccessor = target;
        }
        CreateNavigationNode.prototype.process = function (symbol) {
            try {
                var currentNode = this._nodeAccessor();
                // Create default group
                var defaultGroup = Model.NavigationGroupVM.createDefaultGroup();
                // Check if key of default group exist in current navigation node list
                if (Enumerable.From(currentNode.groups).FirstOrDefault(null, function (_) { return _.key == defaultGroup.key; }) == null) {
                    // Map default group
                    var group = Mapping.parseGroup(defaultGroup);
                    currentNode.groups.push(group);
                }
                var rawNode = { data: { type: symbol, name: "neu", icon: "fa-plus", defaultData: "", groupId: defaultGroup.key } };
                currentNode.raw.children.push(rawNode);
                var node = Mapping.parseNode(rawNode, currentNode);
                currentNode.children.push(node);
                this.output.call(node);
            }
            catch (error) {
                this.error.call(error);
            }
        };
        return CreateNavigationNode;
    }(Parts.Part));
    return CreateNavigationNode;
});

